export const PAK_ADJUSTED_QUANTITY = 1;